<template>
	<div>
	  <a @click="copyData">{{ value }} &nbsp;&nbsp;<i v-if="value" class="fa fa-copy" ></i></a>
	  <input type="hidden" id="testing-code">
	</div>
</template>
<script>
export default {
  props: ['value'],
  methods: {
        copyData (e) {
          let copyValue = document.querySelector('#testing-code')
          copyValue.setAttribute('type', 'text')    // 不是 hidden 才能複製
          copyValue.setAttribute('value',this.value)
          copyValue.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            this.$toasted.info("copied to clipboard..",{duration:500});
          } catch (err) {
            this.$toasted.info("unable to copy value",{duration:500});
          }

          copyValue.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
    },
}
</script>
